<nav
  class="navbar navbar-top navbar-expand navbar-dark bg-psp-bg border-bottom"
  id="navbar-main"
>
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <!-- <div class="collapse navbar-collapse d-flex justify-content-end" id="navbarSupportedContent"> -->
      <ul class="navbar-nav align-items-center ml-md-auto">
      <!-- <ul class="navbar-nav align-items-center ml-md-auto d-none"> -->
        <li class="nav-item d-xl-none">
          <div
            class="pr-3 sidenav-toggler sidenav-toggler-dark"
            data-action="sidenav-pin"
            data-target="#sidenav-main"
            (click)="openSidebar()"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line bg-psp-primary"></i>
              <i class="sidenav-toggler-line bg-psp-primary"></i>
              <i class="sidenav-toggler-line bg-psp-primary"></i>
            </div>
          </div>
        </li>
      </ul>
      <ul class="navbar-nav align-items-center ml-auto ml-md-0">
        <li class="nav-item dropdown" dropdown placement="bottom-right">
          <a class="nav-link pr-0 dropdown-toggle" role="button" dropdownToggle>
            <div class="media align-items-center">
              <div class="media-body ml-2 ">
              <!-- <div class="media-body ml-2"> -->
                <span class="mb-0 text-sm text-psp-primary font-weight-bold">
                  {{ userName != "undefined" ? userName : "Anonymous" }}
                </span>
              </div>
            </div>
          </a>
          <div
            class="dropdown-menu dropdown-menu-arrow dropdown-menu-right"
            *dropdownMenu
          >
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
            </div>
            <div class="dropdown-divider"></div>
            <a (click)="onLogOut()" class="dropdown-item">
              <i class="ni ni-user-run"></i> <span>Logout</span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div
  *ngIf="sidenavOpen === true"
  class="backdrop d-xl-none"
  (click)="toggleSidenav()"
></div>
